import axiosInstance from "./api";

// Helper to handle errors safely
const handleError = (error) => {
  const data = error?.response?.data || {};
  return {
    ...data,
    message: data.message || error.message || "Something went wrong",
    status: error?.response?.status,
    response: error?.response,
  };
};

const isValidMongoId = (id) => /^[a-f\d]{24}$/i.test(String(id || ""));

export const createEvent = async (eventData) => {
  try {
    const response = await axiosInstance.post("/events", eventData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getEvents = async (page = 1, limit = 10, scope = "all", extraParams = {}) => {
  try {
    const response = await axiosInstance.get("/events", {
      params: { page, limit, scope, ...extraParams },
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getEvent = async (id) => {
  try {
    if (!id || !isValidMongoId(id)) {
      throw new Error("Valid Event ID is required");
    }

    const response = await axiosInstance.get(`/events/${id}`);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getRequirementById = async (id) => {
  try {
    if (!id || !isValidMongoId(id)) {
      throw new Error("Valid Requirement ID is required");
    }

    const response = await axiosInstance.get(`/requirements/${id}`);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const updateEvent = async (id, eventData) => {
  try {
    if (!id || !isValidMongoId(id)) {
      throw new Error("Valid Event ID is required");
    }

    const response = await axiosInstance.put(`/events/${id}`, eventData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const deleteEvent = async (id) => {
  try {
    if (!id || !isValidMongoId(id)) {
      throw new Error("Valid Event ID is required");
    }

    const response = await axiosInstance.delete(`/events/${id}`);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getBookedEvents = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/events/bookings", { params });
    return response.data?.events || [];
  } catch (error) {
    throw handleError(error);
  }
};
